import axios, { AxiosError } from 'axios';

import { IOfficeInquiryResult, OfficeInquiryRequestData } from '@/types';
import { useMutation } from '@tanstack/react-query';
import { CREATE_OFFICE_INQUIRY_API_ENDPOINT } from '@/constants';
import { toast } from 'react-toastify';
import { executeCaptcha } from './executeCaptcha';

export const useCreateOfficeInquiry = (
  onSuccess: (data: IOfficeInquiryResult) => void,
  onError?: (statusCode: number | undefined) => void,
) =>
  useMutation<IOfficeInquiryResult, AxiosError, OfficeInquiryRequestData>({
    mutationFn: async ({ officeId, inquiryObj }) => {
      const captchaToken = await executeCaptcha();

      return axios
        .post<IOfficeInquiryResult>(`${CREATE_OFFICE_INQUIRY_API_ENDPOINT}/${officeId}`, {
          ...inquiryObj,
          captchaToken,
        })
        .then((res) => res.data);
    },
    onError: (error) => {
      const statusCode = error.response?.status;
      if (onError) {
        onError(statusCode);
      } else {
        toast.error(error.message);
      }
      console.error(error);
    },
    onSuccess: (data) => {
      onSuccess?.(data);
    },
  });
